import { FailedAuthenticatedPageComponent } from './failed-authenticated-page/failed-authenticated-page.component';
import { IdmAuthenticatedPageComponent } from './idm-authenticated-page/idm-authenticated-page.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CobaltSpinnerModule } from '@msi/cobalt-prime';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const COBALT_PRIME_MODULES = [CobaltSpinnerModule];

@NgModule({
  declarations: [IdmAuthenticatedPageComponent, FailedAuthenticatedPageComponent],
  imports: [CommonModule, TranslateModule, ...COBALT_PRIME_MODULES],
})
export class AuthenticationModule {}
